require('../fhApp/currentUser/currentUser');
require('./redeemPromoService');

"use strict";

angular.module('app.redeemPromo.redeemPromoController', [
  'app.currentUser',
  'app.redeemPromo.redeemPromoService',
  'app.productService'
])
  .controller('app.redeemPromo.redeemPromoController', [
    '$scope',
    '$state',
    'currentUser',
    'app.redeemPromo.redeemPromoService',
    'app.productService',
    'app.shared.teamService',
    function ($scope, $state, currentUser, redeemPromoService, productService, teamService) {
      $scope.has_active_subscription = currentUser.has_active_subscription();
      $scope.teamChecked = false;
      $scope.useTeamSelect = false;
      $scope.planTeams = [];
      $scope.planTeam = { team: null };
      $scope.promoPlan = null;

      let init = function () {
        if (!currentUser.is_logged_in()) {
          $scope.showAuthButtons = true;
        }
      };

      $scope.getPromoPlan = () => {
        redeemPromoService.retrievePlanFromPromo($scope.promo_code).then(function (data) {
          $scope.promoPlan = data.plan;

          if (productService.planUsesTeams($scope.promoPlan) && !$scope.promoPlan.promotion.team_id) {
            teamService.getTeams().then(
              function (response) {
                let data = response.data;

                if (data) {
                  if (data.error) {
                    alert(data.error)
                  } else {
                    $scope.planTeams = data;
                    $scope.useTeamSelect = true;
                    $scope.apply();
                  }
                }
              }
            );
          } else {
            $scope.useTeamSelect = false;
            $scope.planTeams = [];
            $scope.planTeam = { team: null };
          }
        });
      };

      $scope.redeem = () => {

        if (currentUser.is_logged_in()) {
          let params = { plan: $scope.promoPlan };

          if ($scope.promoPlan.promotion && $scope.promoPlan.promotion.team_id) {
            params.team = $scope.promoPlan.promotion.team_id;
          } else if ($scope.useTeamSelect) {
            params.team = $scope.planTeam.team.iteamid;
          }

          let redirect_info = {
            redirect_url: 'app.purchase.billingInfo',
            redirect_params: params
          };

          if (!currentUser.checkUserInfo(redirect_info)) {
            $state.go('app.purchase.billingInfo', params);
          }
        }
      };

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/promo/redeemPromoController.js